import angular from "angular";
import { vsComponentName } from "./component";
import { SelectContractModalConfig } from "./controller";

export const vsServiceName = "selectContractModalService";

export class SelectContractModalService {
  static $inject = ["$uibModal"];

  constructor(private readonly $uibModal: angular.ui.bootstrap.IModalService) {}

  openModal(
    config?: SelectContractModalConfig
  ): angular.ui.bootstrap.IModalInstanceService {
    return this.$uibModal.open({
      component: vsComponentName,
      resolve: {
        contractModalConfig: () => config,
      },
    });
  }
}
